export const products = {
  commercialproducts: [],
  commercialproductsV2: [],
  products: [],
  loading: {
    isLoadingProducts: false,
    isLoadingProductsV2: false,
    isLoadingProduct: false,
  },
  strings: {
    title: 'Products',
    subtitle: undefined,
    'title.product.list': 'Party',
    'title.products.list': 'Products',
    // <PARTIES>
    'products.controls.info.label': 'product(s) found',
    'products.grid.cell.actions.btn.view.label': 'View',
    'products.grid.cell.actions.btn.edit.label': 'Edit',
    'products.grid.cell.actions.btn.cancel.label': 'Cancel',
    'products.grid.cell.actions.btn.modify.label': 'Modify',

    'products.grid.column.id.label': 'Id',
    'products.grid.column.productName.label': 'Subscriber',
    'products.grid.column.status.label': 'Status',
    'products.grid.column.productId.label': 'Party',
    'products.grid.column.createdOn.label': 'Creation Date',
    'products.grid.column.date.label': 'Effective Date',
    'products.grid.column.commercialProductName.label': 'Product',

    'products.grid.column.actions.label': 'Actions',

    'products.filter.label': 'Filtres',
    // </PARTIES>
  },
};
